import React, { useRef } from "react";
import { ActionButton } from "../ActionButton";

interface ExcelImportButtonProps {
  onFileSelect: (file: File) => void | Promise<void>;
  disabled?: boolean;
  loading?: boolean;
  accept?: string;
  label?: string;
  icon?: string;
  className?: string;
}

export const ExcelImportButton: React.FC<ExcelImportButtonProps> = ({
  onFileSelect,
  disabled = false,
  loading = false,
  accept = ".xlsx",
  label = "Importar Excel",
  icon = "⬆",
  className = "",
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";
    await onFileSelect(file);
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={handleChange}
      />
      <ActionButton
        type="button"
        variant="outline"
        size="sm"
        onClick={handleClick}
        disabled={disabled}
        loading={loading}
        icon={icon}
        className={`flex-shrink-0 whitespace-nowrap ${className}`.trim()}
      >
        {label}
      </ActionButton>
    </>
  );
};
